export default __webpack_public_path__ + "static/media/Right arrow.bc28e77b.svg";